import ReactGA from 'react-ga4';
import { useAppSelector } from '@dap/common/data-access';
import { useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import { config } from '@dap/app/config';
import { getHighestAdminRole } from '@dap/memberadmin/utils';

const useGoogleAnalyticsEffect = () => {
  const [hasSetGADimensions, setHasSetGaDimensions] = useState<boolean>(false);
  const selectedBrandKey = useAppSelector(({ brand }) => brand.selectedBrandKey);
  const user = useAppSelector(({ user }) => user.userData.data);
  const location = useLocation();

  useEffect(() => {
    if (config.gaMeasurementId && !hasSetGADimensions && user && !!selectedBrandKey) {
      ReactGA.initialize(config.gaMeasurementId, {
        gtagOptions: {
          mg_brand: selectedBrandKey,
          mg_app: 'dap',
        },
      });
      ReactGA.gtag('set', 'user_properties', {
        admin_role: getHighestAdminRole(user) ?? 'none',
      });
      setHasSetGaDimensions(true);
      ReactGA.event('page_view');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, selectedBrandKey]);

  useEffect(() => {
    ReactGA.event('page_view');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
};

export default useGoogleAnalyticsEffect;
